import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import PaymentTableComponent from './PaymentTableComponent';
import { MakePaymentRequest } from './members.types';
import { updateScheduledPayment } from './members.actions';

type OwnProps = {
  readonly amountPerTransactionError: string
  readonly isItEditMode: boolean
  readonly isContinuousPayment: boolean
  readonly renderAmountEditable: (cellInfo) => void
  readonly renderChargeDateEditable: (cellInfo) => void
  readonly makePaymentRequestHandler: (r: MakePaymentRequest) => void
  readonly makePaymentRequest?: MakePaymentRequest
  readonly handleRedirectToPaymentListPage?: Function
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    toPaymentList: () => dispatch(push(paths.paymentList)),
    updateScheduledPayment: (
      id: number, 
      chargeDate: number, 
      amount: number
    ) => dispatch(updateScheduledPayment(id, chargeDate, amount))
  };
};

const mapStateToProps = (state: AppState, ownProps: OwnProps) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    idleState: state.idleState,
    businessState: state.businessState,
    membersState: state.membersState,
    programsState: state.programsState,
    amountPerTransactionError: ownProps.amountPerTransactionError,
    isItEditMode: ownProps.isItEditMode,
    isContinuousPayment: ownProps.isContinuousPayment,
    renderAmountEditable: ownProps.renderAmountEditable,
    renderChargeDateEditable: ownProps.renderChargeDateEditable,
    makePaymentRequestHandler: ownProps.makePaymentRequestHandler,
    makePaymentRequest: ownProps.makePaymentRequest,
    handleRedirectToPaymentListPage: ownProps.handleRedirectToPaymentListPage
  };
};

const PaymentTable = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(PaymentTableComponent);

export default PaymentTable;



// WEBPACK FOOTER //
// ./src/members/PaymentTable.tsx